import React, { useContext } from 'react';

export const LeftMenuContext = React.createContext();

export const useLeftMenuContext = () => {
  return useContext(LeftMenuContext);
};
